import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const coachingSections = [
    {
        title: "On Breathing",
        quotes: [
            "The exhale is a sigh. Let all the air out. Don't force it.",
            "Feel your ribs come down, forward, and in. Your obliques should turn on, not your six-pack.",
            "Jelly belly on the inhale. Let the air come in silently through your nose.",
            "If you feel your neck kick on while breathing, you're too tense. The brain senses a threat."
        ]
    },
    {
        title: "On Sensation & Cues",
        quotes: [
            "We need to give the brain a reference. Foot on the wall, hand on the ribs.",
            "You should feel a stretch, not a pinch. A pinch is compression where we want expansion.",
            "Find the back of your thigh. That's your hamstring. Not your back.",
            "Can you feel your left heel? That's where we need to be."
        ]
    },
    {
        title: "On Mindset & Application",
        quotes: [
            "This isn't about being perfect. It's about giving your body options it didn't have before.",
            "We are removing the layers of compensation first. You can't fix the foundation if the roof is caved in.",
            "Athletes utilize their pattern for their sport. In-season, we manage it. Off-season, we restore variability.",
            "Think soft meditation and relaxed learning. The less force you apply, the less your brain senses a threat and applies healthy movement patterns."
        ],
        isLarge: true
    }
];

export default function CoachingContent() {
    return (
        <div className="flex flex-col gap-6">
            <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
                {coachingSections.map((section) => (
                    <Card 
                        key={section.title}
                        className={section.isLarge ? "xl:col-span-2" : ""}
                    >
                        <CardHeader>
                            <CardTitle>{section.title}</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-4">
                            {section.quotes.map((quote, index) => (
                                <blockquote key={index} className="border-l-4 border-primary pl-4 italic text-muted-foreground">
                                    {quote}
                                </blockquote>
                            ))}
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
}
